import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="w-full py-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-119">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-2xl w-full" data-id="element-120">
        <div className="rounded-2xl p-8 sm:p-10 flex flex-col items-center text-center relative overflow-hidden" style={{
        background: 'linear-gradient(135deg, #0a0a0a 0%, #111 50%, #0a0a0a 100%)',
        border: '1px solid rgba(201, 168, 76, 0.2)',
        boxShadow: '0 0 40px rgba(201, 168, 76, 0.05), inset 0 1px 0 rgba(201, 168, 76, 0.1)'
      }} data-id="element-121">
          {/* Subtle corner accent */}
          <div className="absolute top-0 right-0 w-32 h-32 opacity-[0.04] pointer-events-none" style={{
          background: 'radial-gradient(circle at top right, #c9a84c, transparent 70%)'
        }} data-id="element-122" />

          <div className="text-4xl mb-4" data-id="element-123">🛡️</div>

          <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-2 tracking-tight" data-id="element-124">
            7 Días de Garantía Total
          </h2>

          <p className="text-brand-gold font-bold text-base sm:text-lg mb-6 leading-relaxed" data-id="element-125">
            Si no te convence, te devolvemos el 100%.
            <br data-id="element-126" />
            Sin preguntas. Sin vueltas.
          </p>

          <div className="flex flex-col gap-2.5 mb-6 w-full max-w-md" data-id="element-127">
            <div className="flex items-center gap-3 text-gray-300 text-sm bg-white/[0.02] rounded-lg px-4 py-2.5" data-id="element-128">
              <span className="text-green-500 shrink-0" data-id="element-129">✓</span>
              <span data-id="element-130">Probá el Mega Pack completo durante 7 días</span>
            </div>
            <div className="flex items-center gap-3 text-gray-300 text-sm bg-white/[0.02] rounded-lg px-4 py-2.5" data-id="element-131">
              <span className="text-green-500 shrink-0" data-id="element-132">✓</span>
              <span data-id="element-133">Si no es lo que esperabas, pedí tu reembolso</span>
            </div>
            <div className="flex items-center gap-3 text-gray-300 text-sm bg-white/[0.02] rounded-lg px-4 py-2.5" data-id="element-134">
              <span className="text-green-500 shrink-0" data-id="element-135">✓</span>
              <span data-id="element-136">Te devolvemos el 100% sin preguntas</span>
            </div>
          </div>

          <p className="text-white font-bold text-lg sm:text-xl mb-6" data-id="element-137">
            El riesgo es cero. La oportunidad es enorme.
          </p>

          <button className="w-full max-w-sm bg-green-500 hover:bg-green-600 text-black font-bold text-base py-3.5 px-6 rounded-xl transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(34,197,94,0.2)]" data-id="element-138">
            QUIERO PROBARLO SIN RIESGO →
          </button>
        </div>
      </motion.div>
    </section>;
}